export default {
  artisan: JSON.parse(localStorage.getItem('artisan')) || {}
}
